var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C8B9D9AF-5D7F-43A8-93AF-47BFF00ECC01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.4405483%",
    cy: "50%",
    fx: "52.4405483%",
    fy: "50%",
    r: "64.4392016%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDF2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.02213948%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB824",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3951D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vial-Mapping_Vial-icons",
    transform: "translate(-357.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(333.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#radialGradient-1)",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(10.000000, 7.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.027282,17.7711614 C4.81215986,17.7711614 3.77999644,17.346559 2.93079176,16.4973543 C2.08158708,15.6481497 1.65698474,14.6159862 1.65698474,13.4008641 L1.65698474,5.40591272 C1.18750573,5.3506799 0.793971856,5.14700886 0.476383113,4.7948996 C0.158794371,4.44279034 0,4.0250921 0,3.54180489 L0,1.88482014 C0,1.37391652 0.186410784,0.932053918 0.559232351,0.559232351 C0.932053918,0.186410784 1.37391652,0 1.88482014,0 L10.1697439,0 C10.6806475,0 11.1225101,0.186410784 11.4953316,0.559232351 C11.8681532,0.932053918 12.054564,1.37391652 12.054564,1.88482014 L12.054564,3.54180489 C12.054564,4.0250921 11.8957696,4.44279034 11.5781809,4.7948996 C11.2605921,5.14700886 10.8670583,5.3506799 10.3975793,5.40591272 L10.3975793,13.4008641 C10.3975793,14.6159862 9.96952487,15.6481497 9.11341608,16.4973543 C8.2573073,17.346559 7.22859594,17.7711614 6.027282,17.7711614 Z M6.027282,16.2177382 C6.6900759,16.2177382 7.27002056,16.0175192 7.76711598,15.6170812 C8.2642114,15.2166432 8.58870425,14.7057396 8.74059452,14.0843703 L6.64865128,14.0843703 C6.42771998,14.0843703 6.24476125,14.0118772 6.09977508,13.8668911 C5.95478892,13.7219049 5.88229584,13.5389462 5.88229584,13.3180149 C5.88229584,13.0970836 5.95478892,12.9106728 6.09977508,12.7587825 C6.24476125,12.6068922 6.42771998,12.5309471 6.64865128,12.5309471 L8.84415606,12.5309471 L8.84415606,11.2882086 L6.64865128,11.2882086 C6.42771998,11.2882086 6.24476125,11.2122634 6.09977508,11.0603732 C5.95478892,10.9084829 5.88229584,10.7289762 5.88229584,10.5218531 C5.88229584,10.2871136 5.95478892,10.0972508 6.09977508,9.95226461 C6.24476125,9.80727844 6.42771998,9.73478536 6.64865128,9.73478536 L8.84415606,9.73478536 L8.84415606,8.4920468 L6.64865128,8.4920468 C6.42771998,8.4920468 6.24476125,8.41610167 6.09977508,8.2642114 C5.95478892,8.11232113 5.88229584,7.92591035 5.88229584,7.70497905 C5.88229584,7.48404775 5.95478892,7.30108902 6.09977508,7.15610286 C6.24476125,7.01111669 6.42771998,6.93862361 6.64865128,6.93862361 L8.84415606,6.93862361 L8.84415606,5.42662503 L3.23112025,5.42662503 L3.23112025,13.4008641 C3.23112025,14.1879319 3.50383232,14.8541778 4.04925646,15.3996019 C4.59468061,15.9450261 5.25402245,16.2177382 6.027282,16.2177382 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.5e6fa5bdcc56f6f503e49776f9d5edb0.svg";
export { ForwardRef as ReactComponent };